// extracted by mini-css-extract-plugin
export default {"container":"bp-z","ratingLayout":"cp-z","ratingLabel":"dp-z","nonInteractiveRatingLabel":"ep-z"};